import { Link } from "react-router-dom";

const Products = () => {
  return (
    <section className="section products" id="products">
      <div className="container">
        <h2 className="products-title">Our Products</h2>

        <div className="grid products-grid">
          <Link to="/optical-frames" className="card product-card">
            <h3 className="product-name">🕶 Optical Frames</h3>
            <p>
              Metal, fiber & rimless frames suitable for all face types.
            </p>
            <span className="tag">Budget + Premium</span>
          </Link>

          <Link to="/branded-lenses" className="card product-card">
            <h3 className="product-name">🔍 Branded Lenses</h3>
            <p>
              Anti-glare, blue-cut, photochromic & progressive lenses.
            </p>
            <span className="tag">Clear Vision</span>
          </Link>

          <Link to="/watch-collections" className="card product-card">
            <h3 className="product-name">⌚ Watch Collections</h3>
            <p>
              Everyday wear, gifting & kids watches available.
            </p>
            <span className="tag">Affordable Style</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Products;
